import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const EmptyHistory = () => (
  <div className="empty_list">
    <div className="empty_list-icon">
      <FontAwesomeIcon icon="list-ul" />
    </div>
    <div className="empty_list-label">
      <p>Without Previous Versions</p>
    </div>
  </div>
);

export default EmptyHistory;
